// extracted by mini-css-extract-plugin
module.exports = {"Header":"styles-module--Header--1AOxw","HeaderIcon":"styles-module--HeaderIcon--1HX8v"};